import { useAppsStore } from '@/stores/apps.store';
import { useAuthStore } from '@/stores/auth.store';
import { usePredictAccessStore } from '@/stores/predict-access.store';

const ADOPTION_AGENT_FLAG = 'adoptionAgent';

// Reactive: reads Pinia state, so nav computeds re-evaluate once access loads.
// A failed lookup stays open so a transient backend error doesn't hide the feature;
// the page surfaces its own error state in that case.
export function hasAdoptionAgentAccess (): boolean {
    const access = usePredictAccessStore();

    if (access.hasLoadError) {
        return true;
    }

    return Boolean(access.analysisAppIds?.some(access.canViewApp));
}

export async function waitForAdoptionAgentAccess (): Promise<void> {
    const auth = useAuthStore();

    // Cypress never delivers segment flags, so waiting would only add the full timeout.
    if (!window.Cypress) {
        await auth.waitForSegmentFlagsReceived();
    }

    if (!auth.hasSegmentFlag(ADOPTION_AGENT_FLAG)) {
        return;
    }

    await Promise.all([
        usePredictAccessStore().load(),
        useAppsStore().loadAll({ reFetch: false }),
    ]);
}
